import React from 'react'
import { Container, Row, Col, Label, Input } from 'reactstrap'
import DropDownTextField from '../view/DropDownTextField'

class ContactInformationViewController extends React.Component{

    renderTextFieldDropDown(var_name, values, onClickRow) {
        return <DropDownTextField value={this.props.model[var_name]}
            values={values}
            onChange={(e) => {
                this.props.onUpdate(var_name, e.target.value)
            }}
            onClickRow={(value, index) => {
                onClickRow(var_name, value, index)
            }} />
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <Label
                            style={{'fontSize': '20pt', 'fontWeight': '400'}}
                        >{this.props.title || "Contact Information"}</Label>
                    </Col>
                </Row>
                <Row xs="1" sm="2">
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>First Name</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {this.renderTextFieldDropDown('first_name',
                                        this.props.firstNames || [], this.props.onClickRow)}
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Last Name</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.last_name}
                                        onChange={(e) => this.props.onUpdate('last_name', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                { true ? <></> :
                <Row>
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Company</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.company}
                                        onChange={(e) => this.props.onUpdate('company', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                }
                <Row xs="1" sm="2">
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Email</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.email}
                                        onChange={(e) => this.props.onUpdate('email', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Row>
                                <Col>
                                    <Label>Phone Number</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Input value={this.props.model.phonenumber}
                                        onChange={(e) => this.props.onUpdate('phonenumber', e.target.value)} />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export { ContactInformationViewController }
